import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GetLocalStroge, SetLocalStroge } from '../functions/local-storage.function';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { token } = GetLocalStroge('login');
    let apiReq;
    if (token) {
      apiReq = request.clone({
        headers: new HttpHeaders({
          // 'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'Accept-Language': 'fa',
        })
      });
    } else {
      apiReq = request.clone({
        headers: new HttpHeaders({
          // 'Content-Type': 'application/json',
          // Authorization: 'Bearer ' + token,
          'Accept-Language': 'fa',
        })
      });
    }
    return next.handle(apiReq).pipe(
      catchError((error) => {
        if (error.error.token) {
          SetLocalStroge('login', { token: error.error.token });
        }
        return throwError(error);
      }),
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event.body.token) {
            SetLocalStroge('login', { token: event.body.token });
          }
        }
      })
    );
  }
}
